import { listViewDefaulttemplate } from "./listviewtemplate";

export const lisComponentTemplate = {
    "typeCode": "",
    "subTypeCode": "",

    "name": "",
    "template":""
}